import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import go from 'gojs';
import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import ReactResizeDetector from 'react-resize-detector';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getClientWindowHeight, getElementBoundingRect, getElementHeight } from '../../store/almightyElementWrapper';
import { chartActions } from '../../store/charts/chartsStore';
import { entityIdentRowActions } from '../../store/entityIdentRowStore';
import { popupActions } from '../../store/popupStore';
import { Circles } from '../common/loadingComponent';
import { czSk } from '../common/reportLinks';
import { isEdge, isIE } from '../common/utils';
import ChartBottomWindow from './chartBottomWindow';
import ChartDiagram from './chartDiagram';
import ChartLegend from './chartLegend';
import ChartCommonTooltip from './chartTooltips/chartCommonTooltip';
import ChartContextMenu from './chartTooltips/chartContextMenu';
import ChartEntityTooltip from './chartTooltips/chartEntityTooltip';
import ChartLinkTooltip from './chartTooltips/chartLinkTooltip';
import ChartTopPanelComponent from './chartTopPanelComponent';

import './relationChart.scss';
import './relationChartFonts.scss'

class RelationChartComponent extends React.Component {
    constructor(props) {
        super(props)
        go.Diagram.licenseKey = "298647e0b3674cc702d90676423d6bf919a175639c8418a30d0310f6e90d3d06329fee2c56d3df9380af4efe1e7dc3d08ac26b209e49503db731d0df45e0d2aab63377a0040e12dea203749398e83aa2fd7b74edc6aa77a0";
    }

    componentDidMount() {
        if (!this.props.charts.domainsInitialized)
            this.props.initializeDomains();
        const that = this;
        this.scrollTemp = window.setTimeout(() => this.scrollCharts(that), 250);
        if (this.isSingleEntityReport()) {
            this.props.ensureEntityInfo(this.props.match.params.id);
        }
    }

    componentWillUnmount() {
        this.props.resetDiagramParams();
    }

    scrollCharts = (_this) => {
        const mustExists = document.getElementById('topSidePanelWrapper');
        const mustExists2 = document.querySelector('.tabs-subheader-wrapper');
        const scrollTarget = document.getElementById('entity-row');
        if (scrollTarget === null || scrollTarget === undefined ||
            mustExists === null || mustExists === undefined ||
            mustExists2 === null || mustExists2 === undefined) {
            _this.scrollTemp = window.setTimeout(() => _this.scrollCharts(_this), 250);
            return;
        }
        if (isIE() || isEdge())
            window.scrollTo(0, scrollTarget.getBoundingClientRect().top);

        else
            window.scrollTo({ top: scrollTarget.getBoundingClientRect().top, behaviour: 'smooth' });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user.language !== this.props.user.language) {
            this.props.initializeDomains();
            this.props.applyFilter();
        }
        if (this.props.charts.sizeChanged) {
            this.props.innerResize();
        }
        if (!this.props.charts.scrolledTo) {
            const pos = getElementBoundingRect('content-body', _ => _.top);
            if (pos !== 0) {
                if (isIE() || isEdge())
                    window.scrollTo(0, pos);
                else
                    window.scrollTo({ top: pos, behaviour: 'smooth' });
                this.props.setScrolled();
            }
        }
        if (this.isSingleEntityReport() && prevProps.match.params.id !== this.props.match.params.id) {
            this.props.ensureEntityInfo(this.props.match.params.id);
        }
        if (!this.isSingleEntityReport() && prevProps.match.params !== this.props.match.params) {
            this.props.initializeDomains();
        }
    }

    height = () => {
        const ch = getClientWindowHeight();
        const vars = [
            getElementHeight({ className: 'page-nav' }),
            getElementHeight({ className: 'report-selection-menu' }),
            getElementHeight({ className: 'report-selection-menu-line-wrapper' }),
            getElementHeight({ className: 'entity-row-wrapper' }),
            getElementHeight({ className: 'page-footer' })
        ];
        return ch - vars.reduce((a, b) => a + b, 0);
    }

    render() {
        if (this.isSingleEntityReport()) {
            return this.renderContentWithPermissionCheck();
        }
        return this.renderContent();
    }

    renderContentWithPermissionCheck() {
        if (!this.isLoaded(this.props.match.params.id, this.props.entityIdentRow.entityInfos)) {
            return null;
        }

        if (this.hasReportPermission(this.props.match.params.id, this.props.entityIdentRow.entityInfos, "FlexiReport", "GeneralReport")) {
            return (this.renderContent());
        } else
            return <Redirect to={`/notAuthorized?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
    };

    renderContent() {
        const h = this.height();
        return (
            <div className="relation-chart-root" style={{ zIndex: 10, display: 'flex', flex: '1 1 auto', flexDirection: 'column', overflow: 'auto', height: `${h}px` }}>
                {this.props.charts.loading && <>
                    <div className="blockUI blockOverlay"></div>
                    <div className="blockUI blockMsg blockPage">
                        <Circles />
                    </div>
                </>}
                {/* ----- this is 99% not used ----- */}
                <div id="nodeSubjectIdInfo" className="panel panel-default subject-id-info-popup">
                    <div className="panel-body">
                        <div className="pull-left" id="subjectIdInfoBody" style={{ paddingRight: '15px' }}></div>
                        <div className="pull-right">
                            <a><span className="rc-button rc-close-btn" title="" role="button" /></a>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
                <div id="expandLimitPopup" className="entity-hover-popup" style={{ left: '50%', top: '50%', transform: 'translateX(-50%) translateY(-50%)' }}>
                    <span style={{ display: 'block', padding: '15px 20px' }}><Translate id="Charts.LevelNotAllowed" /><span id="maxLevel"></span></span>
                </div>
                <div id="reloadNeededPopup" className="entity-hover-popup">
                    <p style={{ fontSize: '10px', margin: 0, maxWidth: '220px', textAlign: 'center' }}><Translate id="Charts.GraphReloadTooltip" /></p>
                    <p style={{ textAlign: 'center', marginBottom: '0px', marginTop: '5px' }}>
                        <a className="rc-button-frame rc-button-text reload-button" style={{ marginRight: '0', minWidth: '110px', fontSize: '10px', cursor: 'pointer' }}>
                            <span style={{ letterSpacing: '.5px', transform: 'none' }}>
                                <FontAwesomeIcon icon="exclamation-triangle" /> <strong><Translate id="Charts.UseFilter" /></strong>
                            </span>
                        </a>
                    </p>
                </div>
                {/* --------------------- */}
                <ChartCommonTooltip />
                <ChartEntityTooltip />
                <ChartLinkTooltip />
                <ChartContextMenu />
                <div id="topBorderPlaceholder" style={{ height: '2px', display: 'flex' }}>&nbsp;</div>
                <ChartTopPanelComponent />
                <div className="m-0" style={{ display: 'flex', flex: '1 0 auto', height: `${h - this.props.charts.topPanel.height - 2}px` }}>
                    <div id="windowContainer" className="column" style={{ overflow: 'hidden', marginTop: '2px', height: '100%', display: 'flex', alignItems: 'stretch', flexDirection: 'column', margin: 0, padding: 0 }} data-html2canvas-ignore>
                        <ChartDiagram />
                        <div id="magnifierDivWindow" style={{ display: 'none' }}>
                            <div id="myMagnifier" style={{ display: 'inline' }}></div>
                        </div>
                        <ChartLegend />
                        <div id="bottomContainer" style={{ position: 'relative', zIndex: 5 }}>
                            <ReactResizeDetector handleHeight handleWidth onResize={this.props.updateBottomWindowHeight}>
                                <>
                                    <div id="bottomContainerResizer" style={{ zIndex: 90, height: '5px', cursor: 's-resize' }} onMouseDown={(e) => this.handleMouseDown(e)}></div>
                                    <div id="overviewDivWindow" style={{ display: 'none' }}>
                                        <span className="rc-button rc-graph-navigation-btn" style={{ position: 'absolute', cursor: 'auto', top: '2px', left: '2px' }}></span>
                                        <a onClick={this.props.toggleOverview}>
                                            <span className="rc-button rc-close-btn" style={{ position: 'absolute', cursor: 'auto', top: '2px', right: '5px', marginTop: '5px' }}></span>
                                        </a>
                                        <div className="overview-header"><span><Translate id="Charts.NavigateWindow" /></span></div>
                                        <div id="myOverview" style={{ display: 'inline' }}></div>
                                    </div>
                                    <ChartBottomWindow />
                                </>
                            </ReactResizeDetector>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleMouseDown = (e) => {
        if (e.button != 0) {
            return;
        }

        window.bottomWindowDrag = {
            bottomHeight: document.getElementById("bottomContainer").offsetHeight,
            mainHeight: document.getElementById("diagramPlane").offsetHeight,
            startY: e.pageY,
            dragging: true
        };

        document.getElementById('windowContainer').addEventListener('mouseup', this.handleMouseUp);
        document.getElementById('windowContainer').addEventListener('mousemove', this.handleMouseMove);

        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
    }

    handleMouseUp = (e) => {
        document.getElementById('windowContainer').removeEventListener('mouseup', this.handleMouseUp);
        document.getElementById('windowContainer').removeEventListener('mousemove', this.handleMouseMove);
        if (window.bottomWindowDrag == null) {
            return;
        }

        window.bottomWindowDrag = undefined;

        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
    }

    handleMouseMove = (e) => {
        if (window.bottomWindowDrag == null || !window.bottomWindowDrag.dragging) {
            return;
        }
        if (e.buttons === 0) {
            this.handleMouseUp(e);
            return;
        }

        var delta = window.bottomWindowDrag.startY - e.pageY;
        if (delta !== 0) {
            document.getElementById("bottomContainer").style.height = (window.bottomWindowDrag.bottomHeight + delta) / (window.bottomWindowDrag.bottomHeight + window.bottomWindowDrag.mainHeight) * 100 + '%';
            document.getElementById("diagramPlane").style.height = (window.bottomWindowDrag.mainHeight - delta) / (window.bottomWindowDrag.bottomHeight + window.bottomWindowDrag.mainHeight) * 100 + '%';

            this.props.requestUpdate();
        }

        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
    }

    isSingleEntityReport() {
        var idsParam = this.props.match.params.id;
        if (idsParam.indexOf('?') !== -1) {
            idsParam = idsParam.substring(0, idsParam.indexOf('?'));
        }
        const ids = idsParam.split(',').map(x => parseInt(x));
        return ids.length === 1;
    }

    isLoaded(id, entityInfos) {
        return id && entityInfos[id] && !entityInfos[id].isRequesting;
    }

    hasReportPermission(id, entityInfos, czRole, skRole) {
        return id && entityInfos[id] && !entityInfos[id].isRequesting && entityInfos[id].result && entityInfos[id].result.reports &&
            czSk(entityInfos[id].result.reports.primaryAttr, czRole, skRole);
    }
}

export default withRouter(withLocalize(connect(
    state => ({ charts: state.charts, layout: state.layout, entityIdentRow: state.entityIdentRow, user: state.userContext }),
    dispatch => bindActionCreators({ ...chartActions, ...popupActions, ...entityIdentRowActions }, dispatch)
)(RelationChartComponent)));